/**
 * @generated SignedSource<<9de4628f5d4a47b5d2fa1670734648d2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueStatsCreatedGraph_IssueStats$data = {
  readonly created: ReadonlyArray<{
    readonly count: number;
    readonly date: string;
  }>;
  readonly resolved: ReadonlyArray<{
    readonly count: number;
    readonly date: string;
  }>;
  readonly " $fragmentType": "IssueStatsCreatedGraph_IssueStats";
};
export type IssueStatsCreatedGraph_IssueStats$key = {
  readonly " $data"?: IssueStatsCreatedGraph_IssueStats$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueStatsCreatedGraph_IssueStats">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "count",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "date",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueStatsCreatedGraph_IssueStats",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssuePerDateStat",
      "kind": "LinkedField",
      "name": "created",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssuePerDateStat",
      "kind": "LinkedField",
      "name": "resolved",
      "plural": true,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "IssueStats",
  "abstractKey": null
};
})();

(node as any).hash = "c6f3d9501d7850e4cfe261e97d4f4d9a";

export default node;
